export default __webpack_public_path__ + "static/media/download.021c1bce.svg";